import * as React from 'react'

import { Button, TextBody } from '@ally/metronome-ui'
import { LinkingSuccessProps } from '@ally/transmitigator'
import { LoginHeading } from '@ally/ally-login'

import { useTransmit } from '../../TransmitContext'
import { AccountDetails, StyledTextBody } from '../Shared'
import { useHostServices } from '../../HostServices'
import {
  AccountLinkingContainer,
  AccountLinkingContentWrapper,
  AccountLinkingScreen,
  AccountLinkingStepper,
  AccountLinkingStepperWrapper,
} from '.'

const LinkingSuccessContent: React.FC<LinkingSuccessProps> = ({
  onComplete,
  status,
  username,
  userData,
  userRelationships,
  error,
}) => {
  const handleContinue = (): void => {
    onComplete()
  }
  const { analytics } = useHostServices()

  React.useEffect(() => {
    analytics.trackPageView({
      eventType: 'pageview',
      pageName: 'AOS:Login:Accounts Linked Successfully',
    })
  }, [])

  return (
    <AccountLinkingContainer>
      <AccountLinkingContentWrapper>
        <LoginHeading title="Nice! We've connected your accounts." />

        <StyledTextBody size="sm" tag="p">
          Now, you&apos;ll manage all of your accounts with this Ally username,{' '}
          <TextBody size="sm" tag="span" weight="bold">
            {username}
          </TextBody>
          . You can edit this info in your Profile.
        </StyledTextBody>

        <AccountDetails username={username} userData={userData} />

        <Button
          allytmln="viewAccounts"
          loading={status === 'Loading'}
          onClick={handleContinue}
          text="View Accounts"
          type="submit"
          variant="primary"
        />
      </AccountLinkingContentWrapper>
      <AccountLinkingStepperWrapper>
        <AccountLinkingStepper
          screen={AccountLinkingScreen.LinkingSuccess}
          userRelationships={userRelationships}
        />
      </AccountLinkingStepperWrapper>
    </AccountLinkingContainer>
  )
}

export const LinkingSuccess: React.FC = () => {
  const { activeScreen } = useTransmit()

  if (activeScreen.type !== 'LinkingSuccess') {
    return null
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <LinkingSuccessContent {...activeScreen.payload} />
}
